
import { apiClient } from "./authService";

export const getDashboardAppointments = async (params: {
  businessId?: string;
  unitId?: string;
  status?: string;
  search?: string;
  startDate?: string;
  endDate?: string;
  page?: number;
  size?: number;
  /** `startAt,asc` or `startAt,desc` (the API's default). */
  sort?: string;
}) => {
  const res = await apiClient.get("/dashboard/appointments", {
    params,
  });

  return res.data;
};
export interface RevenueSummaryResponse {
  totalAppointments: number;
  paidRevenue: number;
  totalExpensesPaid: number;
  projectedRevenue: number;
}

export const getDashboardRevenueSummary = (params: {
  businessId?: string;
  unitId?: string;
  startDate?: string;
  endDate?: string;
}) => {
  return apiClient.get<RevenueSummaryResponse>('/dashboard/appointment-revenue-fast', { params });
};